import { render } from "./deny.vue?vue&type=template&id=485ce803"
import script from "./deny.vue?vue&type=script&lang=js"
export * from "./deny.vue?vue&type=script&lang=js"

import "./deny.vue?vue&type=style&index=0&id=485ce803&lang=less"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__